import { render } from "./GooglePlayIcon.vue?vue&type=template&id=ae3bb9c0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__